import React, { useState } from 'react'
import { changeSiteNameAPi, getSingleDeviceData } from '../../../Api Methods/Api';
import Input from '../../CustomDropDown/Input/Input';
import Button1 from '../../UI/Button/Button1';
import classes2 from "../../forms/InviteUserForm.module.css"
import classes from "./SetTag.module.css"
import { GetSingleDeviceData } from '../../../store/service-actions';
import { serviceActions } from "../../../store/service-Slice";
import { Button } from 'primereact/button';

const ChangeSiteName = ({ placeholder, DeviceUUID, deviceID, HandleCloseModal, dispatch, setUpdateTag, update, setUpdate, siteDevices, setSiteDevices, siteData, setSiteData, isManualSet, headerData, setHeaderData, successModal, errorModal }) => {

    const token = localStorage.getItem('token');
    const client = localStorage.getItem('client');
    const [name, setName] = useState('');

    const handleInputChange = (event) => {
        setName(event.target.value);
    };

    const handleCancel = () => {
        setName('');
        HandleCloseModal();
    };

    const handleSaveTag = async () => {
        const apiData = {
            token,
            client,
        }

        const body = {
            deviceName: name
        }

        const response = await changeSiteNameAPi(apiData, body, DeviceUUID, deviceID, dispatch);
        if (response) {
            HandleCloseModal();
            setUpdate(update+1);
            successModal("Site name successfully updated for all users");

            if (siteData){
                siteData[1].deviceName = name
                dispatch(serviceActions.updatingSingleDeviceData(siteData[1]));  
            }
        } else {
            errorModal("Failed to update site name, please try again")
        }
    }

    return (
        <form onSubmit={handleSaveTag} className={classes2["container"]} method="dialog" >
            <ul className={classes2["inputs-list"]}>
                <li className={classes2["input-container"]}>

                    <Input
                        type="text"
                        value={name}
                        onChange={handleInputChange}
                        placeholder={placeholder}
                    />
                </li>
                <div className={classes.form}>
                    <Button icon="pi pi-times"  onClick={handleCancel} label="Cancel" severity='secondary'/>
                    <Button icon="pi pi-save"  type="submit" label="Save" severity='success'/>
                    
                </div>
            </ul>
        </form>
    )
}

export default ChangeSiteName;